var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20393 4.43555C3.15936 4.43555 0.8125 6.7944 0.8125 9.82698C0.8125 11.9253 1.92336 13.7218 3.55536 14.5327C3.55536 15.3144 2.86964 16.439 2.86964 16.8641C2.86964 17.0973 3.04793 17.1795 3.26736 17.1795C4.44678 17.1521 6.16107 16.1921 6.5725 15.1224C9.60336 14.903 11.5654 12.6538 11.5654 9.82955C11.5654 6.67526 9.34365 4.43812 6.20393 4.43812V4.43555Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M4.78314 11.3641C5.15309 11.3641 5.453 11.0642 5.453 10.6943C5.453 10.3243 5.15309 10.0244 4.78314 10.0244C4.41319 10.0244 4.11328 10.3243 4.11328 10.6943C4.11328 11.0642 4.41319 11.3641 4.78314 11.3641Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M7.48626 11.3641C7.85621 11.3641 8.15612 11.0642 8.15612 10.6943C8.15612 10.3243 7.85621 10.0244 7.48626 10.0244C7.11631 10.0244 6.81641 10.3243 6.81641 10.6943C6.81641 11.0642 7.11631 11.3641 7.48626 11.3641Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.97 7.19579C13.9665 7.33294 11.8828 9.77408 11.8828 12.6687C11.8828 15.8229 14.1731 17.9744 17.12 18.0172C17.7782 19.0732 19.6022 19.8686 20.5074 19.8275C20.7131 19.8138 20.8091 19.7178 20.7542 19.4572C20.576 18.7852 20.2331 17.7566 20.3291 17.1258C21.92 16.2069 22.4822 14.3966 22.4822 12.6129C22.4822 9.33522 19.9451 7.07151 16.9708 7.19579H16.97Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M15.7714 14.2142C16.1414 14.2142 16.4413 13.9143 16.4413 13.5444C16.4413 13.1744 16.1414 12.8745 15.7714 12.8745C15.4015 12.8745 15.1016 13.1744 15.1016 13.5444C15.1016 13.9143 15.4015 14.2142 15.7714 14.2142Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M18.3847 14.2142C18.7547 14.2142 19.0546 13.9143 19.0546 13.5444C19.0546 13.1744 18.7547 12.8745 18.3847 12.8745C18.0148 12.8745 17.7148 13.1744 17.7148 13.5444C17.7148 13.9143 18.0148 14.2142 18.3847 14.2142Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.5L12.2229 3.91422"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6427 0.609863L14.957 3.48986"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81836 18.7144L8.1875 21.2652"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.793 18.543L11.3588 20.0001"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.6cc09511a403cf374a5ef2a4811d9407.svg";
export { ForwardRef as ReactComponent };